<template>
    <a
        v-if="isValid"
        :href="url"
        download
        target="_blank"
        rel="noopener"
        class="flex justify-center border cursor-pointer"
    >
        <slot />
    </a>
</template>

<script>
export default {
    name: "DownloadLink",
    props: {
        url: {
            type: String,
            required: true,
        },
    },
    computed: {
        /**
         * Check if the provided URL is valid (non-empty string).
         * @return {boolean} True if the URL is valid.
         */
        isValid() {
            return this.url && this.url.trim() !== "";
        },
    },
};
</script>
